import { XT_WS_CHANNELS, XT_WS_TOPOLOGY } from './ws';

import type { ExchangeId } from '../../lib/types';

export const XT_METADATA = {
  id: 'xt' as ExchangeId,
  restDocs: [
    'https://doc.xt.com/docs/spot/Market/Get24hStatisticsTicker',
    'https://doc.xt.com/docs/spot/Market/GetDepthData',
    'https://doc.xt.com/docs/spot/Market/GetKlineData',
  ],
  wsDocs: [
    'https://doc.xt.com/docs/spot/WebSocket%20Public',
    'https://doc.xt.com/docs/spot/WebSocket%20Public/OrderbookManage',
  ],
  wsTopology: XT_WS_TOPOLOGY,
  wsChannels: XT_WS_CHANNELS,
  notes: [
    'WebSocket uses plain JSON and client-initiated ping ("ping"/"pong" text).',
    'Orderbook uses incremental depth updates with sequence tracking (fi/i).',
    'Symbol format: lowercase underscore (btc_usdt).',
    'Kline intervals: 1m, 3m, 5m, 15m, 30m, 1h, 2h, 4h, 6h, 8h, 12h, 1d, 3d, 1w, 1M.',
  ],
} as const;
